import { SDKOptions } from "@seontechnologies/seon-javascript-sdk";
import { InfoResponse } from "kz-ui-sdk";
import { SEON_CRITICAL_FEATURES, SEON_DISABLED_FEATURES, SEON_FEATURE } from "./constants";

export const DEFAULT_SEON_CONFIG: SDKOptions = {};

/**
 * Check if SEON is enabled from server info
 * Returns false if serverInfo is null/undefined or seonEnabled is false/undefined
 */
export const isSeonEnabled = (serverInfo: InfoResponse | null | undefined): boolean => {
  return serverInfo?.seonEnabled === true;
};

/**
 * Check if a feature is disabled
 */
export const isFeatureDisabled = (feature: SEON_FEATURE): boolean => {
  return SEON_DISABLED_FEATURES.includes(feature);
};

/**
 * Get SEON config for a specific feature
 * Critical features (deposit, withdrawal) use full accuracy mode (performanceMode: false)
 * Non-critical features use performance mode (performanceMode: true) for better performance
 */
export const getSeonConfigForFeature = (feature?: SEON_FEATURE): SDKOptions => {
  if (!feature) {
    return DEFAULT_SEON_CONFIG;
  }

  const isCritical = SEON_CRITICAL_FEATURES.includes(feature);
  return {
    performanceMode: !isCritical, // true for non-critical, false for critical
  };
};
